import { cameraPtz } from "@/api/device/sensor"
import { Sensor } from "@/global/interface/device/sensor"
import { useState } from "react"
import { message } from "antd";
import JessibucaPlayer from "react-jessibuca";
import { CircleSectorButtons } from "./circle-pad";

interface Iprops {
    url: string
    sensor: Sensor
}

export function MonitorVideoPanel(props: Iprops) {
    const [directionalPadLoading, setDirectionalPadLoading] = useState<boolean>(false); //控制仪表盘的loading状态

    /**
     * 控制摄像头方向
     * @param direction 方向字符串(left, right, down, up, stop) 
     * @returns 
     */
    const move = (direction) => {
        if (directionalPadLoading) {
            return;
        }
        //控制摄像头移动
        //转动参数需要${id},${水平方向},${垂直方向}三个参数
        if (props.sensor.start) {
            message.warning("当前已开启位移识别程序，请于建模端关闭采集后再控制摄像头移动");
            return;
        }
        if (props.sensor && props.sensor.id && props.sensor.sensorParameters && props.sensor.sensorParameters.length > 0) {
            setDirectionalPadLoading(true);
            console.log("我进来咯~~~")
            let params = { "direction": direction };
            let paramId = props.sensor.sensorParameters[0].id;
            cameraPtz(props.sensor.id, paramId, null, params).then(res => {
                setTimeout(function () {
                    cameraPtz(props.sensor.id, paramId, null, { "direction": 'stop' }).then(res => {
                        console.log(res);
                    }).finally(() => {
                        setDirectionalPadLoading(false);
                    })
                }, 3000)
            })
        }

    }


    return (
        <>
            {props.url &&
                <>
                    <JessibucaPlayer
                        src={props.url}
                        decoder='../../../decoder.js'
                        objectFit='fill'
                        config={{ timeout: 7 }}

                        mute
                        onLog={(msg) => { console.log('msg', msg); }}
                        onLoad={() => { console.log('load'); }}
                        onPlay={() => { console.log('play'); }}
                        onTimeout={(err) => { console.log('error', err); }}
                    />
                    <CircleSectorButtons
                        loading={directionalPadLoading}
                        onUp={() => { move("up") }}
                        onDown={() => { move("down") }}
                        onLeft={() => { move("left") }}
                        onRight={() => { move("right") }}
                        size={60}
                        position = {{ bottom: '10px', right: '10px' }}
                    />
                    {/* <DirectionalPad
                        loading={directionalPadLoading}
                        onUp={() => { move("up") }}
                        onDown={() => { move("down") }}
                        onLeft={() => { move("left") }}
                        onRight={() => { move("right") }}
                    /> */}

                </>


            }
            {!props.url && (
                <div className="empty-video">
                    {/* <DisconnectOutlined  style={{
                            fontSize: '40px',
                            marginRight: '10px'
                        }}/> */}
                    <div>正在获取视频信号</div>
                </div>
            )}
        </>
    )

}